import { HTMLAttributes } from 'react';
import { cx } from '../util';

export type ClarionCardProps = HTMLAttributes<HTMLDivElement> & {
  elevation?: 0 | 1 | 2 | 3 | 4;
  compact?: boolean;
  interactive?: boolean;
  ref?: React.RefObject<HTMLDivElement | null>;
};

// Increase brightness to indicate elevation in dark mode
const elevationClasses = {
  0: 'shadow-none dark:bg-gray-800 data-interactive:dark:hover:bg-gray-700/50',
  1: 'shadow-sm dark:bg-gray-700/20 data-interactive:dark:hover:bg-gray-700/60',
  2: 'shadow-md dark:bg-gray-700/40 data-interactive:dark:hover:bg-gray-700/70',
  3: 'shadow-lg dark:bg-gray-700/60 data-interactive:dark:hover:bg-gray-700/80',
  4: 'shadow-xl dark:bg-gray-700/80 data-interactive:dark:hover:bg-gray-700/90',
};

export function ClarionCard({
  elevation = 0,
  compact = false,
  className,
  interactive = false,
  ...props
}: ClarionCardProps) {
  return (
    <div
      className={cx(
        'bg-white rounded-lg border border-gray-200 dark:border-gray-700',
        interactive && 'cursor-pointer hover:bg-gray-50',
        elevationClasses[elevation],
        compact ? 'p-3' : 'p-5',
        className,
      )}
      data-interactive={interactive || undefined}
      {...props}
    />
  );
}
